<div class="col-md-12">
    <div *ngIf="regBlobDataTypeId === RegBlobDataTypeEnum.PictureFromRegistration">
        Photo requirements:
        <ul>
            <li>JPEG format</li>
            <li>10 MB or smaller</li>
            <li>Clear, well lit, and unfiltered</li>
            <li>Background is clear, and the person is the only one in the photo</li>
            <li>Face and shoulders are square to the camera</li>
            <li>Neutral facial expression</li>
            <li>No head coverings or accessories unless worn for religious or medical purposes</li>
            <li>Eyes open and visible, with no eyeglasses unless there is no glare or reflection</li>
            <li>Long hair must be tucked behind ears and shoulders</li>
        </ul>
    </div>
    <form
        name="upload-doc-form"
        [formGroup]="uploadForm"
    >
        <input
            type="file"
            #inputFile
            formControlName="scannedDocument"
            name="scannedDocument"
            accept="image/jpeg"
            (change)="onChangeFile($event)"
        >
        <div
            *ngIf="f.scannedDocument.dirty && (fileExtensionError || fileSizeError)"
            class="error-msg"
        >
            <div
                *ngIf="fileExtensionError"
                class="alert alert-danger"
            >The uploaded file is not a valid JPEG</div>
            <div
                *ngIf="fileSizeError"
                class="alert alert-danger"
            >The chosen file is too large. The maximum file size is 10 MB.</div>
        </div>
        <br />
        <div
            *ngIf="scannedDocumentImg && !fileExtensionError && !fileSizeError"
            class="img-wrapper my-2"
        >
            <img
                [src]="scannedDocumentImg"
                alt="scanned-document"
                class="img-thumbnail"
            >
        </div>
        <div *ngIf="!isUploaded; else uploaded">
            <button
                type="submit"
                name="confirmationYesBtn"
                class="btn btn-primary mt-2"
                [disabled]="uploadForm.invalid ||  fileExtensionError || fileSizeError"
                (click)=uploadFile()
            >{{ regBlobDataTypeId === RegBlobDataTypeEnum.OnlineScannedDocument2 ? "Upload another image" : "Upload" }}</button>
        </div>
        <ng-template #uploaded>
            <button
                type="reset"
                name="resetBtn"
                class="btn btn-primary my-2"
                (click)=reset()
            >Replace Image</button>
            <br />
            <div class="badge badge-success">
                Your {{ regBlobDataTypeId === RegBlobDataTypeEnum.PictureFromRegistration ? "photo" : "scanned document" }} is successfully uploaded
            </div>
        </ng-template>
    </form>
</div>
